Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.js-custom-form');

    if ($wrapper.length <= 0)
        return;

    // reCAPTCHA
    var captchaId = "contactCaptcha";
    var captchaWidgetId;
    var $captchaElement = $wrapper.find("#" + captchaId);
    var $captchaContainer = $wrapper.find('.recaptcha-container');
    var captchaEnabled = $captchaElement.length > 0 ? true : false;
    var wrapper = $wrapper.get(0);

    var formData = {
        firstName: "",
        lastName: "",
        email: "",
        message: "",
        reCaptchaCode: ""
    };

    wrapper.initRecaptcha = function () {

        if (!captchaEnabled)
            return;

        var sitekey = $captchaElement.data("sitekey");
        if (sitekey) {
            captchaEnabled = true;
            captchaWidgetId = grecaptcha.render(captchaId, {
                'sitekey': sitekey,
                'callback': wrapper.recaptchaCallback
            });
        }
    };

    wrapper.recaptchaCallback = function () {
        wrapper.validateRecaptcha();
    };

    wrapper.resetRecaptcha = function () {
        // Website must only verify the user's reCAPTCHA response token (g-recaptcha-response) once. 
        // If a verify attempt has been made with a particular token, it cannot be used again. 
        // Call grecaptcha.reset() to ask the end user to verify with reCAPTCHA again.
        if (captchaEnabled)
            grecaptcha.reset(captchaWidgetId);
    };

    wrapper.removeRecaptcha = function () {
        $captchaElement.remove();
    };

    wrapper.validateRecaptcha = function () {
        if (!captchaEnabled)
            return true;

        formData.reCaptchaCode = $captchaElement.find('.g-recaptcha-response').val();

        var res = false;

        if (formData.reCaptchaCode) {
            $captchaContainer.find('.error-recaptcha').removeClass('error');
            res = true;
        } else {
            $captchaContainer.find('.error-recaptcha').addClass('error');
        }

        return res;
    };


    wrapper.loading = function (loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        }
    };

    var checkConsents = function () {
        var data = [];

        var checkboxes = $('.form-row.consent.checkbox', $wrapper);
        $.each(checkboxes, function (e, el) {
            var chkbx = $('.checkbox-wrapper input', el);
            data.push({ type: chkbx.attr('id'), source: 'Custom Form Page', approved: chkbx.prop("checked") });
        });

        if (data.length > 0) {
            window.ConsentsManager.insertConsents(data);
        } else {
            submit();
        }
    };

    Vendd.MessageBus.subscribe(Vendd.CustomForms.Messages.SubmitSuccess, Vendd.CustomForms, function (envelope) {
        wrapper.loading(false);
        var response = envelope.message.data;
        debugger;
        if (response.Success) {
            $('.js-error', $wrapper).hide();
            $('.js-content', $wrapper).hide();

            $('.js-success', $wrapper).show();

            wrapper.removeRecaptcha();
        } else {
            $('.js-error', $wrapper).show();
            wrapper.resetRecaptcha();
        }
    });

    var submit = function () {
        wrapper.loading(true);
        
        var code = $wrapper.data("code");
        var model = formData;
        var data = { model: model, code: code };

        Vendd.MessageBus.publishAsync('CustomForm', new Vendd.CustomForms.Messages.Submit(data));
    };

    (function ($) {
        $.fn.serializeFormJSON = function () {

            var o = {};
            var a = this.serializeArray();
            $.each(a, function () {
                if (o[this.name]) {
                    if (!o[this.name].push) {
                        o[this.name] = [o[this.name]];
                    }
                    o[this.name].push(this.value || '');
                } else {
                    o[this.name] = this.value || '';
                }
            });
            return o;
        };
    })(jQuery);

    $('.js-send-custom-form').click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var val1 = cf.validate();
        var val2 = wrapper.validateRecaptcha();
        
        if (val1 && val2) {
            if (LhApp.Context.IsConsentsEnabled) {
                checkConsents();
            } else {
                submit();
            }
        }
    });

    $wrapper.on('keyup', 'input[name], textarea[name]', function (e) {
        if (e.keyCode == 13) {

            if ($(this).prop("tagName").toLowerCase() === "textarea")
                return true;

            e.preventDefault();
            e.stopPropagation();

            $submitButton.click();

            return;
        };

        var $this = $(this);
        var fieldName = $this.attr('name');

        formData[fieldName] = $this.val();

        cf.validate(fieldName);
    });

    //init validation options
    var validationOptions = {
        firstName: {
            required: 'firstname-required'
        },
        lastName: {
            required: 'lastname-required'
        },
        email: {
            required: 'email-required',
            isEmail: 'email-invalid'
        },
        message: {
            required: 'message-required'
        }
    };

    //add consent validations
    $.each($('.consent.checkbox[data-required]'), function (e, el) {
        var consentType = $('input', el).attr('name');
        validationOptions[consentType] = {
            checkboxRequired: consentType + '-required'
        };
    });


    $wrapper.validationEngine(validationOptions);
    var cf = $wrapper.data('validationEngine');

    if ($(".view-terms", $wrapper).length > 0) {
        $(".view-terms", $wrapper).fancybox();
    }

    Vendd.MessageBus.subscribe(Vendd.Plugins.Messages.RecaptcaLoaded, wrapper, wrapper.initRecaptcha);
    Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertConsents, $wrapper, submit);
});